import React from 'react';
import "./CarruselMarcasStyle.css";
import { marcas } from '../../config/config';
import { Link } from 'react-router-dom';
import styled from 'styled-components';


export const CarruselMarcas = () => {
  const country = process.env.REACT_APP_COUNTRY;
  const marcasPais = marcas[country];

  const Title = styled.h2`
    font-size: 48px;
    margin: 0 0 36px;
    color: #515151;
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1.15em;
    text-transform: uppercase;
    text-align: center;
    span {
      color: red;
    }
    @media (max-width: 768px) {
      font-size: 1.8em;
      margin-top: 10px;
    }
  `;

  return (

    <div className='mt-5'>
        <Title>Marcas líderes del mercado disponibles en <span>Solution Box</span></Title>
      <div className='slider mt-5'>
      
        <div className='slide-track'>
          {marcasPais.map((marca, index) => (
            <Link key={index} to={`/marcas/${marca.id}`}>
              <div className="slide">
                <img
                  src={`${process.env.PUBLIC_URL}/${marca.src}`}
                  alt={marca.alt}
                  width="55%"
                  height="auto"
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};